import { useSyncExternalStoreWithSelector } from 'use-sync-external-store/shim/with-selector';
import { useSmartLinkContext } from '@atlaskit/link-provider';
const PENDING_STATE = {
  status: 'pending'
};
export function useSmartCardState(url) {
  const {
    store
  } = useSmartLinkContext();
  const cardState = useSyncExternalStoreWithSelector(store.subscribe, store.getState, store.getState, state => state[url]);
  return cardState !== null && cardState !== void 0 ? cardState : PENDING_STATE;
}